import type { CSSObject } from "@emotion/react";

export const buttonsContainerCss: CSSObject = {
  display: "flex",
  gap: "20px",
  alignItems: "center",
};
